export default __webpack_public_path__ + "8940158c4a1fb8236987a67593513596.png";